// extracted by mini-css-extract-plugin
module.exports = {"filters-wrapper":"Art_filters-wrapper__q3dGx","results-found":"Art_results-found__eMmLC","spacer":"Art_spacer__7IYw_"};